module.exports = __webpack_public_path__ + "static/media/doc.6b414605.jpg";